import React, { Component } from 'react';

import stepImg from '../../assets/images/activity/detail1.png';
import ruleImg from '../../assets/images/activity/detail2.png';
import applyImg from '../../assets/images/activity/detail3.png';
import qrImage from '../../assets/images/activity/expandQR.png';

class SpreadAssist extends Component {
  render () {
    const type = this.props.match.params.type;
    return (
      <div>
        {type === 'step' && <img src={stepImg} alt="" width='100%' />}
        {type === 'rule' && <img src={ruleImg} alt="" width='100%' />}
        {type === 'apply' && <img src={applyImg} alt="" width='100%' />}
        {type === 'qr' && <img src={qrImage} alt="" width='100%' />}
        {type === 'intro' &&
          <video width='100%' controls>
            <source src='https://cdn.fujfu.com/fubaodai_introduce_video.mp4' type="video/mp4"/>
          </video>}
      </div>
    )
  }
}

export default SpreadAssist;
